import { useTranslation } from "@redotech/redo-i18n";
import type { OrderTagState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { RedoTagInputField } from "@redotech/redo-web/arbiter-components/input/redo-tag-input-field";
import { memo, useMemo, useState } from "react";

export const OrderTagDetails = memo(function OrderTagDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<OrderTagState>) {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");

  const tags = useMemo(
    () => state.map((tag) => ({ text: tag, color: "gray" as const })),
    [state],
  );

  return (
    <RedoTagInputField
      delimiters={["newline"]}
      description={t("Order tag at the time of return.")}
      inputValue={inputValue}
      label={t("Order tags")}
      placeholder={t("Type and press Enter to add tags")}
      setInputValue={setInputValue}
      setTags={setState}
      size="sm"
      state={disabled ? "disabled" : "default"}
      tags={tags}
    />
  );
});
